/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { css } from 'styled-components';
import Button from '@vfuk/core-button';

const internalLinkAsButtonWrapperStyles = css`
  padding: 10px 0;
`;

type InternalLinkProps = {
  label: string;
  href: string;
  seoString: string;
};

const SeoGatsbyLink = ({ label, href, seoString }: InternalLinkProps) => {
  const onClickHandler = () => {
    let seoEventText = 'V-Hub:' + document.title + ':' + label + ':';
    const seoNo = seoString.slice(-1);
    if (seoNo !== '0') {
      seoEventText = seoEventText + seoNo + ':';
    }
    seoEventText = seoEventText + 'CTA';

    if (
      window.utag &&
      window.utag.link &&
      typeof window.utag.link === 'function'
    ) {
      window.utag.link({
        link_name: seoEventText,
        tealium_event: 'link',
      });
    }
  };

  return (
    <div css={internalLinkAsButtonWrapperStyles}>
      <Button
        text={label}
        appearance="primary"
        onClick={onClickHandler}
        href={href}
        htmlAttributes={{ target: '_blank' }}
      />
    </div>
  );
};

export default SeoGatsbyLink;
